"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperCardGrid = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var StyledWrapperCardGrid = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(", ", 1fr));\n  grid-template-rows: auto;\n  grid-row-gap: 2rem;\n  grid-column-gap: 2rem;\n"], ["\n  width: 100%;\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(", ", 1fr));\n  grid-template-rows: auto;\n  grid-row-gap: 2rem;\n  grid-column-gap: 2rem;\n"])), function (_a) {
    var minWidth = _a.minWidth;
    return minWidth;
});
var WrapperCardGrid = function (_a) {
    var style = _a.style, className = _a.className, children = _a.children, id = _a.id, _b = _a.minWidth, minWidth = _b === void 0 ? '30rem' : _b;
    return (react_1.default.createElement(StyledWrapperCardGrid, { id: id, style: style, className: className, minWidth: minWidth }, children));
};
exports.WrapperCardGrid = WrapperCardGrid;
var templateObject_1;
